// FR
export const calendarsChatbotHc = {
  monthlyCalendar: {
    pricesTitle: "Tarification dynamique",
    prices: "Prix",
    noPropertiesAvailable: "Aucun logement disponible",
    noPropertiesFound: "Aucun logement trouvé",
    minStayShort: "min. {n}n",
    available: "Disponible",
    closed: "Fermé",
    loading: "Chargement…",
    showMoreMonths: "Afficher plus de mois",
    from: "Du",
    to: "Au",
    nightsLabelOne: "{n} nuit",
    nightsLabelMany: "{n} nuits",
    whatToDo: "Que souhaitez-vous faire ?",
    close: "Fermer",
    open: "Ouvrir",
    price: "Prix",
    minStay: "Séjour min.",
    closeReasonPlaceholder: "Motif de la fermeture (facultatif)",
    openHint: "Les dates sélectionnées seront rouvertes (le blocage est retiré).",
    nightsWord: "nuits",
    clearSelection: "Effacer la sélection",
    past: "Passée",
    guestOne: "voyageur",
    guestMany: "voyageurs",
    perNight: "/ nuit",
    noName: "Sans nom",
    channelDirect: "Directe",
    ownerBlockComment: "Blocage par le propriétaire",
    prepTime: "Temps de préparation",
    sameDayCutoff: "Fermeture le jour même",
    linkedClosed: "Vente entière",
    linkedClosedInfo: "Fermé par la vente de l'appartement entier ({motivo}). Il se rouvrira tout seul si cette réservation est annulée ou change de dates.",
    alsoLinked: "également fermé par la vente de l'appartement entier ({motivo})",
    applyClose: "Fermer les dates",
    applyOpen: "Ouvrir les dates",
    applyPrice: "Enregistrer le prix",
    applyMinStay: "Enregistrer le séjour minimum",
    apply: "Appliquer",
    processing: "Traitement…",
    closingDates: "Fermeture des dates…",
    openingDates: "Ouverture des dates…",
    priceModeLabel: "Mode de prix",
    priceModeFixed: "Fixe",
    priceModePercent: "%",
    priceModeAmount: "Montant",
    percentPlaceholder: "Ex. 20",
    amountPlaceholder: "Ex. 10",
    percentHint: "Chaque nuit est recalculée sur son propre prix. Avec − ça baisse.",
    amountHint: "S’ajoute à ce que coûte déjà chaque nuit. Avec − ça baisse.",
    invalidPrice: "Saisissez un prix valide.",
    changingPrice: "Modification du prix par nuit…",
    priceUpdated: "Prix mis à jour avec succès.",
    priceUpdateError: "Impossible de mettre à jour le prix.",
    minStayMin: `Le séjour minimum doit être d'au moins 1 nuit.`,
    changingMinStay: "Modification du séjour minimum…",
    minStayUpdated: "Séjour minimum mis à jour avec succès.",
    minStayUpdateError: "Impossible de mettre à jour le séjour minimum.",
    unknownError: "Erreur inconnue",
  },
  calendar: {
    channelDirect: "Directe",
    searchMin2: "Saisissez au moins 2 caractères pour rechercher",
    searchNoResults: "Aucune réservation trouvée pour cette recherche",
    searchError: "Erreur lors de la recherche de réservations",
    processing: "Traitement…",
    ownerBlockComment: "Blocage par le propriétaire",
    cutoffTip: "Fermeture des ventes le jour même à {time}",
    nightsLabelOne: "{n} nuit",
    nightsLabelMany: "{n} nuits",
    turnoverBefore: "Temps de préparation : bloquez {nights} avant chaque arrivée",
    turnoverAfter: "Temps de préparation : bloquez {nights} à partir de chaque départ",
    turnoverBoth: `Temps de préparation : bloquez {nights} avant l'arrivée et à partir du départ`,
    selectAtLeastOneProperty: "Sélectionnez au moins un logement.",
    selectAtLeastOneDate: "Sélectionnez au moins une date effective pour appliquer les modifications.",
    preparingOps: "Préparation de {total} opérations...",
    applyingOps: "Application de {index} sur {total} : {name}",
    unknownError: "Erreur inconnue",
    couldNotSaveChanges: `Impossible d'enregistrer les modifications.`,
    bulkApplyError: `Impossible d'appliquer les modifications groupées. {message}`,
    opsApplied: "{success} sur {total} opérations ont été appliquées.",
    opsSkipped: "{skipped} dates avec des réservations confirmées ont été ignorées.",
    opsFailed: "{failed} opérations ont échoué.",
    bulkApplied: "Édition groupée appliquée à {count} logements.",
    couldNotOpenDate: `Impossible d'ouvrir la date`,
    datesOpened: "Dates ouvertes",
    closeUpdated: "Blocage mis à jour",
    todayLabel: `Aujourd'hui`,
    closed: "Fermé",
    linkedClosed: "Vente entière",
    linkedClosedInfo: "Fermé par la vente de l'appartement entier ({motivo}). Il se rouvrira tout seul si cette réservation est annulée ou change de dates.",
    alsoLinked: "également fermé par la vente de l'appartement entier ({motivo})",
    closingDates: "Fermeture des dates…",
    couldNotCloseDates: "Impossible de fermer les dates",
    clearFiltersTitle: "Effacer les filtres",
    noPropertiesAvailable: "Aucun logement disponible",
    noPropertiesFound: "Aucun logement trouvé",
    dynamicPricesTitle: "Tarification dynamique",
    prices: "Prix",
    viewWide: "Vue large",
    viewCompact: "Vue compacte",
    viewNormal: "Vue normale",
    viewFull: "Voir en entier",
    searchBookingTitle: "Rechercher une réservation",
    searchBookingPlaceholder: "Rechercher une réservation…",
    search: "Rechercher",
    resultsSelectOne: "{count} résultats — sélectionnez-en un :",
    bulkEdit: "Édition groupée",
    goToTodayTitle: `Aller à aujourd'hui`,
    showHeader: `Afficher l'en-tête`,
    configArrivalDeparture: `Configurer les règles d'arrivée et de départ`,
    notAvailable: "Indisponible",
    extension: "Prolongation",
    lateCheckoutUntil: "Départ tardif jusqu'à {time}",
    aiRequests: "Réception IA",
    guestComments: "Remarques du client",
    internalNotes: "Notes internes",
    extrasTitle: "Extras achetés",
    extrasPending: "En attente de confirmation",
    reqArrivalTitle: "Heure d'arrivée",
    reqAt: "à {time}",
    reqUntil: "jusqu'à {time}",
    reqNights: "Nuits en plus : {n}",
    reqPending: "En attente",
    reqConfirmed: "Confirmée",
    reqPaid: "Payée",
    reqOffered: "Proposée",
    reqPrioritised: "Prioritaire",
    pendingAmount: "Reste à payer :",
    noticesColumn: "Alertes",
    callsTitle: "Appels",
    callsCount: "Appels : {n}",
    extensionPaid: "Prolongation payée",
    listCheckin: "Arrivée",
    listCheckout: "Départ",
    priceOriginal: "Réservation initiale",
    priceExtension: "Prolongation",
    priceTotal: "Total",
    paymentInProcess: "Paiement en cours",
    overbooking: "Surréservation",
    noAccommodationsFound: `Aucun logement trouvé pour "{term}".`,
    past: "Passée",
    paymentInProcessLower: "paiement en cours",
    pendingApproval: `en attente d'approbation`,
    pendingApprovalTitle: "En attente d'approbation",
    guestOne: "voyageur",
    guestMany: "voyageurs",
    perNight: "/ nuit",
  },
  tableFilters: {
    filterByDate: "Filtrer par date du - au",
    filterByCountry: "Filtrer par pays",
    all: "Tous",
    countrySpain: "Espagne",
    countryColombia: "Colombie",
    countryBrazil: "Brésil",
    filterByState: "Filtrer par statut",
    allStates: "Tous les statuts",
    stateDemo: "Version démo",
    stateSubscribed: "Abonnés",
    stateNotSubscribed: "Non abonnés",
    searchRecords: "Rechercher dans les enregistrements",
  },
  chatbotPageIndex: {
    aiAgentBadge: "Agent IA",
    planFeatureHint: "Fonctionnalité disponible avec un forfait payant.",
    otaAgentTitle: "Agent IA pour les OTA",
    otaAgentHint: `Activez-le pour que l'agent réponde automatiquement aux messages de Booking, Airbnb et d'autres OTA.`,
    otaRequiresWhatsapp: `Nécessite que l'agent IA WhatsApp soit actif.`,
    guardNotice: `Lorsque l'agent IA est désactivé, le chat passe aussi automatiquement en <strong>réponse manuelle</strong>. Les interrupteurs par conversation resteront bloqués jusqu'à ce que vous le réactiviez.`,
    configureBasic: `Configurer l'agent IA basique`,
    configureAdvanced: `Configurer l'agent IA avancé`,
    comingSoon: "Bientôt disponible",
    detailFallback: "Détail",
    errorLoadListingConfig: `Impossible de charger la configuration de l'annonce`,
    errorSaveChange: `Erreur lors de l'enregistrement de la modification`,
    otaAgentActivated: "Agent IA pour les OTA activé",
    otaAgentDeactivated: "Agent IA pour les OTA désactivé",
  },
  chatbotIndex: {
    accommodationFallback: "Logement",
    defaultHandoffSupportLine: "\nSi vous avez besoin d'une assistance rapide, contactez-nous au {phone} 📞",
    defaultHandoffMessage: "Bonjour 😊 Je n'ai pas cette information pour le moment, mais un membre de notre équipe vous répondra bientôt 🙌{suffix}\nNous restons à votre disposition tout au long de votre séjour ! 🏡✨",
    silentModeMessage: `Aucune réponse automatique ne sera envoyée au voyageur. Le système continuera à notifier l'opérateur afin qu'il puisse poursuivre la conversation.`,
    statusNoGuestReply: "Aucune réponse au voyageur",
    statusUsingCustom: "Message personnalisé utilisé",
    statusUsingDefault: "Message par défaut utilisé",
    helperSilent: `Le voyageur ne recevra pas de réponse automatique lorsque l'agent IA ne sait pas quoi répondre, mais l'opérateur recevra la notification pour reprendre la conversation.`,
    helperCustom: "Le système traduira automatiquement ce message personnalisé dans la langue du voyageur.",
    helperHasCustom: `Vous avez un message personnalisé enregistré, mais pour l'instant le système continuera d'utiliser le message par défaut.`,
    helperDefault: `Si vous créez un message maître, vous pourrez l'activer ici et le système le traduira automatiquement dans la langue du voyageur.`,
    sourceSilent: "Silencieux",
    sourceCustom: "Personnalisé",
    sourceDefault: "Par défaut",
    defaultBotName: "Mon Assistant Virtuel",
    errorLoadBotName: `Impossible de charger le nom de l'assistant.`,
    errorLoadHandoff: "Impossible de charger le message de transfert.",
    botNameUpdated: `Nom de l'assistant mis à jour.`,
    errorSaveBotName: `Impossible d'enregistrer le nom de l'assistant.`,
    masterMessageUpdated: "Message maître mis à jour.",
    errorSaveMaster: "Impossible d'enregistrer le message maître.",
    warnCreateCustomFirst: `Créez d'abord un message personnalisé avant de l'activer.`,
    modeCustomActivated: "Le message personnalisé sera désormais utilisé.",
    modeSilentActivated: `Le bot restera silencieux lorsqu'il ne saura pas répondre, mais l'opérateur continuera d'être notifié.`,
    modeDefaultActivated: "Le message par défaut sera désormais utilisé.",
    errorUpdateActiveMessage: "Impossible de mettre à jour le message actif.",
    warnWriteQuestion: `Écrivez une question avant d'enregistrer.`,
    questionCreated: "Question créée avec succès.",
    errorAddQuestion: `Impossible d'ajouter la question.`,
    botNamePlaceholder: `Nom de l'assistant`,
    handoffRowTitle: `Message lorsque l'agent ne sait pas répondre`,
    customize: "Personnaliser",
    expandAria: "Développer",
    handoffSubtitle: `Ce texte sera envoyé lorsque l'agent IA ne trouvera pas la réponse dans les facts, la mémoire ou les FAQ.`,
    modeDefaultTitle: "Message par défaut",
    modeDefaultDesc: `Utilise le message standard du système avec le numéro d'assistance.`,
    modeCustomTitle: "Message personnalisé",
    modeCustomDescActive: "Activez le texte personnalisé que vous avez enregistré dans la fenêtre.",
    modeCustomDescEmpty: `Vous n'avez pas encore créé de message personnalisé.`,
    modeSilentTitle: "Ne pas répondre au voyageur",
    modeSilentDesc: `Le voyageur ne reçoit pas de message automatique, mais l'opérateur sera notifié pour poursuivre la conversation.`,
    loadingMessage: "Chargement du message...",
    masterMessage: "Message maître",
    newQuestionTitle: "Nouvelle question",
    newQuestionSubtitle: `Créez une nouvelle question fréquente pour que l'agent IA puisse y répondre avec plus de précision.`,
    guestQuestionLabel: "Question du voyageur",
    questionPlaceholder: `Ex. : à quelle heure est l'arrivée ?`,
    questionHelp: "Conseil : rédigez la question comme le ferait un vrai voyageur.",
    cancel: "Annuler",
    saveQuestion: "Enregistrer la question",
    handoffKicker: "Réponse de transfert",
    handoffModalTitle: "Personnaliser le message maître",
    handoffModalSubtitle: "Rédigez un seul message en espagnol. Le système le traduira automatiquement et répondra selon la langue parlée par le voyageur.",
    masterToolbarInfo: "Vous pouvez utiliser des emojis et un ton chaleureux, comme dans vos autres messages automatiques.",
    emojiSearchPlaceholder: "Rechercher un emoji...",
    masterTextareaPlaceholder: "Rédigez ici le message maître. Vous pouvez utiliser des emojis et un ton chaleureux pour le voyageur.",
    masterHint: `Recommandation : rédigez le message en espagnol avec le ton exact que vous souhaitez transmettre. Le système l'adaptera automatiquement à la langue du voyageur.`,
    viewDefaultMessage: "Voir le message par défaut",
    saveMessage: "Enregistrer le message",
    newButton: "Nouvelle",
    emojiButton: "Emoji",
  },
  messageAccountDemo: {
    usingDemo: "Vous utilisez la version démo",
    ofThePlatform: "de la plateforme",
    trialHave: "Il vous reste encore",
    trialDaysToEnjoy: "jours pour profiter de toutes les fonctionnalités !",
    trialSubscribeNow: "Abonnez-vous maintenant et continuez à gérer vos logements sans interruption.",
    subscribeNowLabel: `S'abonner maintenant`,
  },
};
